import { useTranslation } from 'react-i18next';
import { ExportTemplateCard } from './ExportTemplateCard.tsx';
import {
  RememberFieldsCheckbox,
  TemplateCardWrapper,
  TemplateSelectWrapper,
} from './ExportTemplateSection.styles.ts';
import { ExportTemplateSelect } from './ExportTemplateSelect.tsx';
import { type ExportTemplateConfig } from './useExportTemplate.ts';

interface ExportTemplateSectionProps {
  templateConfig: ExportTemplateConfig;
  showTemplates: boolean;
  onSelect: (fields: string[]) => void;
  localStorageData: {
    saveFlag: boolean;
    setSaveFlag: (value: boolean) => void;
  };
}

export function ExportTemplateSection(props: ExportTemplateSectionProps) {
  const { templateConfig, showTemplates, onSelect, localStorageData } = props;
  const { t } = useTranslation();

  if (showTemplates) {
    return (
      <>
        <TemplateSelectWrapper>
          <ExportTemplateSelect
            {...templateConfig.templateSelectProps}
            onSelect={onSelect}
          />
        </TemplateSelectWrapper>
        <TemplateCardWrapper>
          <ExportTemplateCard {...templateConfig.templateCardProps} />
        </TemplateCardWrapper>
      </>
    );
  }

  return (
    <RememberFieldsCheckbox
      checked={localStorageData.saveFlag}
      onChange={v => localStorageData.setSaveFlag(v.target.checked)}
    >
      {t(
        'export-file-button.remember-fields',
        'Ricorda i campi per la prossima esportazione',
      )}
    </RememberFieldsCheckbox>
  );
}
